import React from 'react'
import { ModalBody, Input, Label, Row, Col } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { DropDownList } from '@/components/dropDownList'
import ErrorBoundary from '@/components/ErrorBoundary'
import Resx from '@/components/Resx'
import context from '@/context'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'

class AddDashboardWidgetDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      widgetType: null,
      rowsCount: 5
    }
  }
  saveChanges = () => {
    this.props.onAction(this.state)
  }
  render () {
    const { localize } = this.props
    return (
      <ValidationBoundary>
        <BasicHeader title='Common.Add' {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            <Row>
              <Label sm={3}><Resx name='Common.Widget' />: </Label>
              <Col sm={9}>
                <div className='mb-2'>
                  <Validator name='widgetType' value={this.state.widgetType} required>
                    <DropDownList
                      dataSource={context.api.dashboardService.getLookupItems}
                      transform={data => data.map(item => ({ id: item.id, name: localize(`Enums.${item.name}`) }))}
                      textField='name'
                      onChange={({ value }) => this.setState({ widgetType: value })}
                      value={this.state.widgetType}
                    />
                  </Validator>
                </div>
              </Col>
            </Row>
            <Row>
              <Label sm={3}><Resx name='Common.RowsCount' />: </Label>
              <Col sm={9}>
                <div className='mb-2'>
                  <Validator
                    name='rowsCount'
                    value={this.state.rowsCount}
                    required
                    min={1}
                    max={100}
                  >
                    <Input type='number'
                      className='form-control'
                      placeholder={localize('Common.RowsCount')}
                      title={localize('Common.RowsCountMinimumTitle')}
                      value={this.state.rowsCount}
                      onChange={(e) => this.setState({ rowsCount: e.target.value })} />
                  </Validator>
                </div>
              </Col>
            </Row>
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...this.props} onAction={this.saveChanges} disabled={!isValid} />
        } />
      </ValidationBoundary>
    )
  }
}

export default {
  component: AddDashboardWidgetDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/addDashboardWidget.js